import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  dotNumberValidation,
  dotNumberBlurValidation,
  withDotValidation,
} from "../../../../helpers/global_helper";
import ConfirmBetDeskonPopup from "../../../Popups/ConfirmBetDeskonPopup";
import BetSuccessPopup from "../../../Popups/BetSuccessPopup";
import ErrorPopup from "../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../Popups/ErrorInnerPopup";
import { withTranslation } from "react-i18next";
import { getUserBalance, setCommonConfig } from "../../../../redux/actions";
import GameClosedPopup from "../GameClosedPopup";
import MarketClose from "../MarketClose";
import CommonBetHeader from "../CommonBetHeader";

const Kombinasi = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const device = useSelector((state) => state.CommonConfig.device_type);
  const [rowsToShow, setRowsToShow] = useState(5);
  const [rowsToShow1, setRowsToShow1] = useState(5);
  const [rowsToShow2, setRowsToShow2] = useState(5);
  const [tableData1, setTableData1] = useState(
    Array.from({ length: rowsToShow }, () => ({
      Guess1: "",
      Guess2: "",
      Buy: "",
    }))
  );
  const [tableData2, setTableData2] = useState(
    Array.from({ length: rowsToShow1 }, () => ({
      Guess1: "",
      Guess2: "",
      Buy: "",
    }))
  );
  const [tableData3, setTableData3] = useState(
    Array.from({ length: rowsToShow2 }, () => ({
      Guess1: "",
      Guess2: "",
      Buy: "",
    }))
  );
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [allTableData, setAllTableData] = useState([]);
  const [combinedResults, setCombinedResults] = useState({
    gameId: null,
    gameType: "kombinasi",
    dataangka: [],
    action: "process",
    betTogelAuth: "betTogelAuth",
  });
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [SubmitRespData, setSubmitRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [totalBetAmount, setTotalBetAmount] = useState(0);
  const [autoBetValue, setAutoBetValue] = useState('');
  const belliRefs = useRef([[], [], []]);
  const [prizeDiscount, setPrizeDiscount] = useState();
  const [kepalaEkorAutoBet, setKepalaEkorAutoBet] = useState('');
  const [positionAutoBet, setPositionAutoBet] = useState('');

  const handleAutoBet = (value, type = '') => {
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }

    if (value > betDiscount.showMax / 1000) {
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }

    if (regex.test(value)) {
      if (type === 'kepala-ekor') {
        setKepalaEkorAutoBet(value);
      } else if (type === 'position') {
        setPositionAutoBet(value);
      } else {
        setAutoBetValue(value);
      }
    } else {
    }
  }


  const handleAutoBetBlur = (value, type = '') => {
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      if (type === 'kepala-ekor') {
        setKepalaEkorAutoBet(value);
      } else if (type === 'position') {
        setPositionAutoBet(value);
      } else {
        setAutoBetValue(value);
      }
    } else {
    }
  };

  useEffect(() => {
    calculateTotalBetAmount(); // Only calculate when any of the tableData changes
  }, [tableData1, tableData2, tableData3]);

  useEffect(() => {
    makeAjax(url.TOGEL_API.getTogelDetails, { "gameId": gameId, "gameType": combinedResults.gameType }).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      setPrizeDiscount(response.data.showDisc);
    })
  }, [gameId])

  const handleFocus = (e, rowIndex, columnName, tableIndex, autoBetType = '') => {
    // Check if autoBetValue is set and the input field is empty
    let currentAutoBetValue = '';

    if (autoBetType === 'kepala-ekor') {
      currentAutoBetValue = kepalaEkorAutoBet;
    } else if (autoBetType === 'position') {
      currentAutoBetValue = positionAutoBet;
    } else {
      currentAutoBetValue = autoBetValue;
    }

    if (currentAutoBetValue && !e.target.value) {
      let newData;
      switch (tableIndex) {
        case 0:
          newData = [...tableData1];
          newData[rowIndex][columnName] = currentAutoBetValue;
          setTableData1(newData);
          break;
        case 1:
          newData = [...tableData2];
          newData[rowIndex][columnName] = currentAutoBetValue;
          setTableData2(newData);
          break;
        case 2:
          newData = [...tableData3];
          newData[rowIndex][columnName] = currentAutoBetValue;
          setTableData3(newData);
          break;
        default:
          break;
      }
    }
  };

  const calculateTotalBetAmount = () => {
    let total = 0;
    // Sum the "Buy" values for each table and apply the discount
    const discountFactor = prizeDiscount ? 1 - (prizeDiscount / 100) : 1; // Fallback to 1 if prizeDiscount is not set

    const sumBuyValues = (tableData) => {
      return tableData.reduce((acc, curr) => {
        const buyValue = parseFloat(curr.Buy) || 0;
        return acc + buyValue * betDiscount.showMultiple * discountFactor; // Apply the dynamic discount on each Buy value
      }, 0);
    };

    total += sumBuyValues(tableData1);
    total += sumBuyValues(tableData2);
    total += sumBuyValues(tableData3);

    setTotalBetAmount(total);
  };

  const handleInputBlur = (e, rowIndex, columnName, tableIndex) => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    e.target.value = value;
    handleInputChange(e, rowIndex, columnName, tableIndex);
  }

  const handleInputChange = (e, rowIndex, columnName, tableIndex) => {
    let { value } = e.target;
    value = value.replace(',', '.');
    let newData;
    let minValue = betDiscount.showMin / 1000;
    let maxValue = betDiscount.showMax / 1000;

    const tables = [tableData1, tableData2, tableData3];

    if (columnName === "Buy") {
      let regex = '';
      if (String(betDiscount.showMin).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberValidation(value);
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }

      if (!regex.test(value)) {
        clearBetValue(rowIndex, tableIndex, columnName);
      }
      // else if (value < minValue && value) {
      //   setErrorMessage(props.t("minimum_bet_is_1"));
      //   setShowErrorPopup(true);
      //   clearBetValue(rowIndex, tableIndex, columnName);
      // } 
      else if (value > maxValue) {
        setErrorMessage(props.t("The_bet_has_exceeded_the_maximum_bet"));
        setShowErrorPopup(true);
        clearBetValue(rowIndex, tableIndex, columnName);
      }
      newData = [...tables[tableIndex]];
      newData[rowIndex][columnName] = value;
    } else {
      newData = [...tables[tableIndex]];
      newData[rowIndex][columnName] = value;
      switch (tableIndex) {
        case 0:
          setTableData1(newData);
          break;
        case 1:
          setTableData2(newData);
          break;
        case 2:
          setTableData3(newData);
          break;
        default:
          break;
      }

      const isGuess1Filled = newData[rowIndex].Guess1;
      const isGuess2Filled = newData[rowIndex].Guess2;

      if (isGuess1Filled && isGuess2Filled) {
        let betValue;
        if (tableIndex === 0) {
          betValue = autoBetValue;
        } else if (tableIndex === 1) {
          betValue = kepalaEkorAutoBet;
        } else {
          betValue = positionAutoBet;
        }
        newData[rowIndex].Buy = betValue;
        tables[tableIndex] = newData;
        belliRefs.current[tableIndex][rowIndex].focus();
      }

    }

    newData = [...tables[tableIndex]];
    newData[rowIndex][columnName] = value;

    switch (tableIndex) {
      case 0:
        setTableData1(newData);
        break;
      case 1:
        setTableData2(newData);
        break;
      case 2:
        setTableData3(newData);
        break;
      default:
        break;
    }
    calculateTotalBetAmount();
  };

  const clearBetValue = (rowIndex, tableIndex, columnName) => {
    let newData;
    if (belliRefs.current[tableIndex][rowIndex]) {
      belliRefs.current[tableIndex][rowIndex].value = "";
    }

    switch (tableIndex) {
      case 0:
        newData = [...tableData1];
        newData[rowIndex][columnName] = "";
        setTableData1(newData);
        break;
      case 1:
        newData = [...tableData2];
        newData[rowIndex][columnName] = "";
        setTableData2(newData);
        break;
      case 2:
        newData = [...tableData3];
        newData[rowIndex][columnName] = "";
        setTableData3(newData);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const combinedData = [
      ...tableData1.map((row) => ({ ...row })),
      ...tableData2.map((row) => ({ ...row })),
      ...tableData3.map((row) => ({ ...row })),
    ];
    setAllTableData(combinedData);
  }, [tableData1, tableData2, tableData3]);

  useEffect(() => {
    const results = [];
    allTableData.forEach((row) => {
      if (row.Guess1 && row.Guess2 && row.Buy) {
        results.push([
          `${row.Guess1}-${row.Guess2}`,
          row.Buy * betDiscount.showMultiple,
          "success",
        ]);
      }
    });
    setCombinedResults((prevState) => ({
      ...prevState,
      gameId: gameId,
      dataangka: results,
    }));
  }, [allTableData]);

  const resetAllData = () => {
    setTableData1(
      Array.from({ length: rowsToShow }, () => ({
        Guess1: "",
        Guess2: "",
        Buy: "",
      }))
    );
    setTableData2(
      Array.from({ length: rowsToShow1 }, () => ({
        Guess1: "",
        Guess2: "",
        Buy: "",
      }))
    );
    setTableData3(
      Array.from({ length: rowsToShow2 }, () => ({
        Guess1: "",
        Guess2: "",
        Buy: "",
      }))
    );
    setAutoBetValue('');
    setKepalaEkorAutoBet('');
    setPositionAutoBet('');
    setAllTableData([]);
    setCombinedResults({
      gameId: null,
      gameType: "kombinasi",
      dataangka: [],
      action: "process",
      betTogelAuth: "betTogelAuth",
    });
    setTotalBetAmount(0);
    setErrorMessage("");
    setShowErrorPopup(false);
    setSubmitRespData([]);
    setSuccessPopup(false);
    setShowConfirmationPopup(false);
  };

  const processSubmit = () => {
    let valid = true;

    if (combinedResults.dataangka.length === 0) {
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
      return;
    }

    // for (const row of allTableData) {
    //   const { Guess1, Guess2, Buy } = row;
    //   if (
    //     (Guess1 && !Guess2) ||
    //     (!Guess1 && Guess2) ||
    //     (Guess1 && Guess2 && !Buy)
    //   ) {
    //     setErrorMessage(props.t("guess_bet_wrong_place"));
    //     setShowConfirmationPopup(true);
    //     valid = false;
    //     break;
    //   }
    // }

    if (valid) {
      setErrorMessage("");
      setShowConfirmationPopup(true);
    }
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.processAltTogel, combinedResults).then(
      (response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
          if (response.code !== "validation_error") {
            setErrorMessage(props.t(response.code))
            setShowErrorPopup(true);
            return;
          }
          showMessage("server error No data find", "error", "error");
          return;
        }
        resetAllData();
        setSubmitRespData((prevData) => [...prevData, response.data]);
        dispatch(getUserBalance());
        setSuccessPopup(true);
      }
    );
  };

  return (
    <div className="kombinasi_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {device === "Desktop" ? (
            <>

              {/* <CommonBetHeader gameName={"colokBebas"} totalBetAmount={totalBetAmount} rowsToShow={null} /> */}


              <div className="kombinasi_container">
                <table style={{ marginBottom: 5 }}>
                  <thead>
                    <tr>
                      {/* <th className="nopadding_noborder" style={{ width: 50 }}>&nbsp;</th> */}
                      {/* <th className="nopadding_noborder">&nbsp;</th> */}
                      {/* <th className="nopadding_noborder">&nbsp;</th> */}
                      {/* <th> */}
                      {/* <input
                          type="text"
                          placeholder="auto bet"
                          value={autoBetValue}
                          onChange={(e) => handleAutoBet(e.target.value)}
                        /> */}
                      <CommonBetHeader gameName={"kombinasi"} totalBetAmount={totalBetAmount} rowsToShow={null} />

                      {/* </th> */}
                    </tr>
                  </thead>
                </table>
              </div>
              <div className="kombinasi_heading">
                <h1>2 KOMBINASI AS - KOP</h1>
              </div>
              <div className="kombinasi_container">
                <table>
                  <thead>
                    <tr>
                      <th>{props.t("no.")}</th>
                      <th>{props.t("guess")} AS</th>
                      <th>{props.t("guess")} Kop</th>
                      <th style={{ width: "32%" }} className="nopadding_noborder">
                        <input
                          type="text"
                          placeholder="Auto Bet"
                          value={autoBetValue}
                          onChange={(e) => handleAutoBet(e.target.value)}
                          onBlur={(e) => handleAutoBetBlur(e.target.value)}
                        />
                      </th>
                      {/* <th>
                        {props.t("buy")}{" "}
                        <span className="small_input">1=1000</span>
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(rowsToShow)].map((_, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td>{index + 1}</td>
                        <td className="inputs">
                          <select
                            value={tableData1[index].Guess1}
                            name={`as-${index}`}
                            onChange={(e) =>
                              handleInputChange(e, index, "Guess1", 0)
                            }
                          >
                            <option></option>
                            <option value="As_Ganjil">
                              As {props.t("odd")}
                            </option>
                            <option value="As_Genap">
                              As {props.t("even")}
                            </option>
                            <option value="As_Besar">
                              As {props.t("big")}
                            </option>
                            <option value="As_Kecil">
                              As {props.t("small")}
                            </option>
                          </select>
                        </td>
                        <td className="inputs">
                          <select
                            value={tableData1[index].Guess2}
                            name={`kop-${index}`}
                            onChange={(e) =>
                              handleInputChange(e, index, "Guess2", 0)
                            }
                          >
                            <option></option>
                            <option value="Kop_Ganjil">
                              Kop {props.t("odd")}
                            </option>
                            <option value="Kop_Genap">
                              Kop {props.t("even")}
                            </option>
                            <option value="Kop_Besar">
                              Kop {props.t("big")}
                            </option>
                            <option value="Kop_Kecil">
                              Kop {props.t("small")}
                            </option>
                          </select>
                        </td>
                        <td className="inputs">
                          <input
                            type="text"
                            placeholder="Bet"
                            name={`belli-${index}`}
                            value={tableData1[index].Buy}
                            onChange={(e) =>
                              handleInputChange(e, index, "Buy", 0)
                            }
                            onBlur={(e) =>
                              handleInputBlur(e, index, "Buy", 0)
                            }
                            disabled={
                              !tableData1[index].Guess1 ||
                              !tableData1[index].Guess2
                            }
                            ref={(el) => (belliRefs.current[0][index] = el)}
                            onFocus={(e) => handleFocus(e, index, "Buy", 0)}
                            inputMode="decimal"
                            pattern="[0-9]*[.,]?[0-9]**"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="kombinasi_heading" style={{ marginTop: "10px" }}>
                <h1>2 KOMBINASI KEPALA - EKOR</h1>
              </div>
              <div className="kombinasi_container">
                <table>
                  <thead>
                    <tr>
                      <th>{props.t("no.")}</th>
                      <th>{props.t("guess")} Kepala</th>
                      <th>{props.t("guess")} Ekor</th>
                      <th style={{ width: "32%" }} className="nopadding_noborder">
                        <input
                          type="text"
                          placeholder="Auto Bet"
                          value={kepalaEkorAutoBet}
                          onChange={(e) => handleAutoBet(e.target.value, 'kepala-ekor')}
                          onBlur={(e) => handleAutoBetBlur(e.target.value, 'kepala-ekor')}

                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                        />
                      </th>
                      {/* <th>
                        {props.t("buy")}{" "}
                        <span className="small_input">1=1000</span>
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(rowsToShow1)].map((_, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td>{index + 1}</td>
                        <td className="inputs">
                          <select
                            value={tableData2[index].Guess1}
                            name={`kepala-${index}`}
                            onChange={(e) =>
                              handleInputChange(e, index, "Guess1", 1)
                            }
                          >
                            <option></option>
                            <option value="Kepala_Ganjil">
                              Kepala {props.t("odd")}
                            </option>
                            <option value="Kepala_Genap">
                              Kepala {props.t("even")}
                            </option>
                            <option value="Kepala_Besar">
                              Kepala {props.t("big")}
                            </option>
                            <option value="Kepala_Kecil">
                              Kepala {props.t("small")}
                            </option>
                          </select>
                        </td>
                        <td className="inputs">
                          <select
                            value={tableData2[index].Guess2}
                            name={`ekor-${index}`}
                            onChange={(e) =>
                              handleInputChange(e, index, "Guess2", 1)
                            }
                          >
                            <option></option>
                            <option value="Ekor_Ganjil">
                              Ekor {props.t("odd")}
                            </option>
                            <option value="Ekor_Genap">
                              Ekor {props.t("even")}
                            </option>
                            <option value="Ekor_Besar">
                              Ekor {props.t("big")}
                            </option>
                            <option value="Ekor_Kecil">
                              Ekor {props.t("small")}
                            </option>
                          </select>
                        </td>
                        <td className="inputs">
                          <input
                            type="text"
                            placeholder="Bet"
                            name={`belli-${index}`}
                            value={tableData2[index].Buy}
                            onChange={(e) =>
                              handleInputChange(e, index, "Buy", 1)
                            }
                            onBlur={(e) =>
                              handleInputBlur(e, index, "Buy", 1)
                            }
                            disabled={
                              !tableData2[index].Guess1 ||
                              !tableData2[index].Guess2
                            }
                            ref={(el) => (belliRefs.current[1][index] = el)}
                            onFocus={(e) => handleFocus(e, index, "Buy", 1, 'kepala-ekor')}
                            inputMode="decimal"
                            pattern="[0-9]*[.,]?[0-9]**"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="kombinasi_heading" style={{ marginTop: "10px" }}>
                <h1>2 KOMBINASI ALL POSISI</h1>
              </div>
              <div className="kombinasi_container">
                <table>
                  <thead>
                    <tr>
                      <th>{props.t("no.")}</th>
                      <th>{props.t("guess")}</th>
                      <th>{props.t("guess")}</th>
                      <th style={{ width: "32%" }} className="nopadding_noborder">
                        <input
                          type="text"
                          placeholder="Auto Bet"
                          value={positionAutoBet}
                          onChange={(e) => handleAutoBet(e.target.value, 'position')}
                          onBlur={(e) => handleAutoBetBlur(e.target.value, 'position')}

                        />
                      </th>
                      {/* <th>
                        {props.t("buy")}{" "}
                        <span className="small_input">1=1000</span>
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(rowsToShow2)].map((_, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td>{index + 1}</td>
                        <td className="inputs">
                          <select
                            value={tableData3[index].Guess1}
                            name={`guess1-${index}`}
                            onChange={(e) =>
                              handleInputChange(e, index, "Guess1", 2)
                            }
                          >
                            <option></option>
                            <option value="As_Ganjil">
                              As {props.t("odd")}
                            </option>
                            <option value="As_Genap">
                              As {props.t("even")}
                            </option>
                            <option value="As_Besar">
                              As {props.t("big")}
                            </option>
                            <option value="As_Kecil">
                              As {props.t("small")}
                            </option>
                            <option value="Kop_Ganjil">
                              Kop {props.t("odd")}
                            </option>
                            <option value="Kop_Genap">
                              Kop {props.t("even")}
                            </option>
                            <option value="Kop_Besar">
                              Kop {props.t("big")}
                            </option>
                            <option value="Kop_Kecil">
                              Kop {props.t("small")}
                            </option>
                          </select>
                        </td>
                        <td className="inputs">
                          <select
                            value={tableData3[index].Guess2}
                            name={`guess2-${index}`}
                            onChange={(e) =>
                              handleInputChange(e, index, "Guess2", 2)
                            }
                          >
                            <option></option>
                            <option value="Kepala_Ganjil">
                              Kepala {props.t("odd")}
                            </option>
                            <option value="Kepala_Genap">
                              Kepala {props.t("even")}
                            </option>
                            <option value="Kepala_Besar">
                              Kepala {props.t("big")}
                            </option>
                            <option value="Kepala_Kecil">
                              Kepala {props.t("small")}
                            </option>
                            <option value="Ekor_Ganjil">
                              Ekor {props.t("odd")}
                            </option>
                            <option value="Ekor_Genap">
                              Ekor {props.t("even")}
                            </option>
                            <option value="Ekor_Besar">
                              Ekor {props.t("big")}
                            </option>
                            <option value="Ekor_Kecil">
                              Ekor {props.t("small")}
                            </option>
                          </select>
                        </td>
                        <td className="inputs">
                          <input
                            type="text"
                            placeholder="Bet"
                            name={`belli-${index}`}
                            value={tableData3[index].Buy}
                            onChange={(e) =>
                              handleInputChange(e, index, "Buy", 2)
                            }
                            onBlur={(e) =>
                              handleInputBlur(e, index, "Buy", 2)
                            }
                            disabled={
                              !tableData3[index].Guess1 ||
                              !tableData3[index].Guess2
                            }
                            ref={(el) => (belliRefs.current[2][index] = el)}
                            onFocus={(e) => handleFocus(e, index, "Buy", 2, 'position')}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="last_div">
                <div className="left_div">
                  <p>{props.t("kombinasi_text")}</p>
                </div>
                <div className="right_div">
                  <ul className="button-list">
                    <li>
                      <button className="reset" onClick={resetAllData}>
                        {props.t('reset')}
                      </button>
                    </li>
                    <li>
                      <button className="submit" onClick={processSubmit}>
                        {props.t('submit')}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              {showConfirmationPopup && (
                <ConfirmBetDeskonPopup
                  onClose={() => setShowConfirmationPopup(false)}
                  message={errMessage}
                  submitProcessOk={submitProcessOk}
                />
              )}
              {successPopup && (
                <div className="popup-overlay">
                  <BetSuccessPopup
                    response={SubmitRespData}
                    onClose={() => setSuccessPopup(false)}
                  />
                </div>
              )}
              {showErrorPopup && (
                <ErrorInnerPopup
                  modalTitle={""}
                  modalHeader={true}
                  onCloseModal={() => setShowErrorPopup(false)}
                >
                  <ErrorPopup
                    message={errMessage}
                    onClose={() => setShowErrorPopup(false)}
                  />
                </ErrorInnerPopup>
              )}
            </>
          ) : (
            ""
          )}
        </>
      )}
    </div>
  );
};

export default withTranslation()(Kombinasi);
